import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaHome, FaPlus, FaQuestionCircle, FaUserTag } from 'react-icons/fa';
import { IoLogOut, IoPerson } from 'react-icons/io5';
import { MdDelete, MdModeEdit } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar2 from '../Sidebar/Sidebar2';
import { useLocation } from "react-router-dom";
import { IoMdArrowDropdownCircle, IoMdMenu } from 'react-icons/io';
import "./EmailTemplate.css";
import ReactQuill from 'react-quill';
import { ImCross } from 'react-icons/im';
import { RiArrowDropDownLine, RiArrowDropUpLine } from 'react-icons/ri';
import { FaWandMagicSparkles } from 'react-icons/fa6';

// --- Main App Component ---
export default function EmailTemplate() {
  // State to manage which view is currently visible ('list' or 'add')
  const [view, setView] = useState('list');
  const location = useLocation();
  useEffect(() => {
    if (location.state?.view === "add") {
      setView("add");
    }
  }, [location.state]);
  useEffect(() => {
    console.log("location.state:", location.state);
  }, [location.state]);
  const [editTemplate, setEditTemplate] = useState(null);
  // State to hold the list of email templates
  const [templates, setTemplates] = useState([

  ]);


const[guideData,setGuideData]=useState("")

  useEffect(() => {
    let isCalled = false;
    const fetchTemplates = async () => {
      if (isCalled) return;
      isCalled = true;

      const token = sessionStorage.getItem("authToken");
      try {
        const response = await axios.get(`https://tracsdev.apttechsol.com/api/view-template-list`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const fetchedTemplates = response.data.templates.data;
        setTemplates(fetchedTemplates);
 setGuideData(response.data?.guidetips?.description)
        const initialStatuses = {};
        fetchedTemplates.forEach((template) => {
          initialStatuses[template.id] = template.status === "1";
        });

      } catch (err) {
        console.log(err.response?.data?.message || "Failed to fetch templates.");
      }
    };

    fetchTemplates();
  }, []);


  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [name, setName] = useState("")
const[Heading,setHeading]=useState("")
  const [subtitle, settitle] = useState("")
  const fetchProfile = async () => {
    try {
      const token = sessionStorage.getItem("authToken");
      const response = await axios.get("https://tracsdev.apttechsol.com/api/my-profile", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = response.data;

      setName(data.user.name || "");
      settitle(data.helpnote.find(item => item.id === 8)?.description);
 setHeading(data.helpnote.find(item => item.id === 8)?.page_url);
      setImagePreview(
        data?.user?.image
          ? `https://tracsdev.apttechsol.com/public/${data.user.image}`
          : "https://tracsdev.apttechsol.com/public/uploads/user_avatar.jpeg"
      );



    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };
  useEffect(() => {
    fetchProfile();
  }, []);


  // Function to toggle the status of a template
  // Function to toggle the status of a template
  const handleStatusToggle = async (id, currentStatus) => {
    const token = sessionStorage.getItem("authToken");

    // toggle logic
    const newStatus = currentStatus === "1" ? "0" : "1";

    try {
      await axios.post(
        "https://tracsdev.apttechsol.com/api/update-template-status",
        {
          id: id,
          status: newStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // update UI only after success
      setTemplates((prevTemplates) =>
        prevTemplates.map((template) =>
          template.id === id
            ? { ...template, status: newStatus }
            : template
        )
      );
    } catch (error) {
      console.error("Status update failed", error);
      alert("Failed to update status");
    }
  };


  const handleDelete = async (id) => {
    const token = sessionStorage.getItem("authToken");

    try {
      await axios.get(
        `https://tracsdev.apttechsol.com/api/destroy-template/${id}`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const updatedTemplates = templates.filter((template) => template.id !== id);
      setTemplates(updatedTemplates);


    } catch (err) {
      console.error("Delete failed:", err);


    }
  };
  const handleEditTemplate = (template) => {
    setEditTemplate(template);
    setView("edit");
  };

  // Function to handle form submission (for now, it just logs to console and switches view)
  const handleAddTemplate = (e) => {
    e.preventDefault();
    // In a real app, you would process form data here
    console.log("New template saved!");
    setView('list'); // Switch back to the list view
  };
  const Icon = ({ name, className = "w-6 h-6" }) => {
    const icons = {
      'credit-card': <><path d="M2 9a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9Z" /><path d="M2 14h20" /></>,
      'user': <><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></>,
      'lock': <><rect width="18" height="11" x="3" y="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></>,
      'link': <><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.72" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.72-1.72" /></>,
      'inbox': <><polyline points="22 12 16 12 14 15 10 15 8 12 2 12" /><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" /></>,
      'users': <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></>,
      'mail': <><rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" /></>,
      'pen-square': <><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></>,
      'help-circle': <><circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><path d="M12 17h.01" /></>,
      'thumbs-up': <><path d="M7 10v12" /><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a2 2 0 0 1 1.01.27Z" /></>,
      'message-square': <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />,
      'book-open': <><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" /><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" /></>,
      'menu': <><line x1="4" x2="20" y1="12" y2="12" /><line x1="4" x2="20" y1="6" y2="6" /><line x1="4" x2="20" y1="18" y2="18" /></>,
      'chevron-down': <path d="m6 9 6 6 6-6" />,
      'x': <><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>,
      'plus': <><path d="M5 12h14" /><path d="M12 5v14" /></>,
    };

    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
        {icons[name]}
      </svg>
    );
  };



  const [Heasderdropdown, setHeaderdropdown] = useState(null);
  const showDropDown = () => {
    setHeaderdropdown(prev => !prev)
  }
  const navigate = useNavigate();
  const handleLogout = () => {
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("userId")
 localStorage.removeItem("authToken")
    sessionStorage.removeItem("profileImageUrl")

    navigate("/"); // Redirect to login page
    window.location.reload();
  };
  const [showSideNav, setSideNav] = useState(false);
  return (
    <div style={{ display: "flex", height: "100vh", overflowY: "auto" }}>
      <div className="hidden lg:block fixed w-[17%]"><Sidebar2 /></div>{showSideNav && <div><Sidebar2 /></div>}
      <div className="bg-gray-100 text-gray-800 min-h-screen font-sans" style={{ width: "100%" }}>
        <header className="bg-white shadow-sm flex items-center justify-between p-1 border-b">
          <div className="flex items-center gap-2">
            {/* MOBILE MENU BUTTON */}
            <button
              onClick={() => setSideNav(prev => !prev)}
              className="lg:hidden p-2 rounded-md bg-gray-100 hover:bg-gray-200"
            >
              <IoMdMenu className="w-6 h-6 text-gray-700" />
            </button>
            <h1 className="text-2xl font-semibold text-gray-800 ml-4 lg:ml-0"></h1>
          </div>

          <div className="flex items-center space-x-4">
            <div style={{ marginRight: "15px" }}><Link to="/"><FaHome size={28} /></Link></div>
            <div className="relative">
              <button className="flex items-center space-x-2" onClick={showDropDown}>
                <img src={imagePreview} alt="User Avatar" className="h-10 w-10 rounded-full" />
                <span className="hidden md:block">{name}</span>
                <Icon name="chevron-down" className="w-4 h-4" />
              </button>
              {Heasderdropdown && <div className="dropDown3" >
                <Link
                  to="/dashboard"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div className="profileDrop">
                    <div style={{ marginTop: "2px", marginRight: "6px" }}><IoPerson /></div>
                    <div> <p>Dashboard</p></div>

                  </div>
                </Link>
                <div className="dropLogout" onClick={handleLogout}>
                  <div style={{ marginTop: "2px", marginRight: "6px" }}><IoLogOut /></div>
                  <div>    <p>Logout</p></div>

                </div>
              </div>}
            </div>
          </div>
        </header>
        <div className="bg-gray-100 m p-4 md:p-8 ml-0 md:ml-[17%] w-full md:w-[83%] h-[100vh]  overflow-y-auto md:overflow-y-visible ">
          {view === 'list' ? (
            <TemplateListView
            Heading={Heading}
              templates={templates}
              subtitle={subtitle}
              onAddNew={() => setView('add')}
              onStatusToggle={handleStatusToggle}
              onDelete={handleDelete}
              onEdit={handleEditTemplate}
              guideData={guideData}
            />
          ) : view === 'add' ? (
            <AddTemplateFormView
              onBack={() => setView('list')}
              onCancel={() => setView('list')}
            />
          ) : (
            <EditTemplateFormView
              template={editTemplate}          // 👈 Pass data here
              onBack={() => setView('list')}
              onCancel={() => setView('list')}
            />
          )}

        </div>
      </div></div>
  );
}

// --- Template List View Component ---
const TemplateListView = ({ templates, onAddNew,Heading, onStatusToggle, onDelete, onEdit, subtitle ,guideData}) => {
  const [open, setOpen] = useState(false);
    const [guide, setGuide] = useState(false);
    const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};
  return (
    <div style={{ paddingBottom: "60px" }}>
      <div className="MessageIntroButt">
        <div><h2 className='intoHeading' style={{ color: "#334e6f" }}><div dangerouslySetInnerHTML={{ __html: Heading }} /></h2>
        </div>
         <p className='IntroPara'>{stripHtml(subtitle)}</p>
      </div>
   
 <div className="flex flex-col sm:flex-row justify-between items-center mb-6 mt-2 ">
  <div className='makeIntoButton'> <button onClick={onAddNew}><div style={{ marginRight: "10px", marginTop: "3px" }}><FaPlus color='white' /></div>Add Email Template</button></div>
        <button className='guideButton' onClick={() => setGuide((prev) => !prev)}><span style={{ marginTop: "2.5px", marginRight: "7px" }}><FaQuestionCircle /></span>Guide and Tips <span style={{ marginTop: "-4px", marginLeft: "5px" }}>{guide ? <RiArrowDropUpLine size={28} /> : <RiArrowDropDownLine size={28} />}</span></button>

      </div>
      {guide && <div className="bg-white p-6 sm:p-8 rounded-xl shadow-md animate-fade-in mb-4">
          <div dangerouslySetInnerHTML={{ __html: guideData }} />
      </div>}
      <div className="bg-white p-6 rounded-xl shadow-md animate-fade-in mt-[30px]" >

        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">

        </div>

        <div className="overflow-x-auto" >
          <table className="min-w-full bg-white border border-gray-200 rounded-lg">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Body</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Updated On</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {templates.map(template => {

                const singleLinePreview = template.email_body
                  ?.replace(/<[^>]+>/g, " ")
                  .replace(/\s+/g, " ")
                  .trim();

                return (
                  <tr key={template.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {template.template_name}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {template.category_id === "6"
                        ? "Reply-Email"
                        : template.category_id === "1"
                          ? "Introduction-Email"

                          : template.category_id === "4"
                            ? "Follow-up"
                            : template.category_id === "5"
                              ? "Member-Email"
                              : template.category_id?.toString()}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 truncate max-w-xs">
                      {singleLinePreview}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {new Date(template.created_at).toLocaleString("en-US", {
                        month: "short",
                        day: "2-digit",
                        year: "numeric",
                      })}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      <span
                        onClick={() => onStatusToggle(template.id, template.status)}
                        className={`cursor-pointer px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${template.status === "1"
                          ? "bg-green-100 text-green-800"
                          : "bg-red-100 text-red-800"
                          }`}
                      >
                        {template.status === "1" ? "Active" : "Inactive"}
                      </span>
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium flex mt-4">
                      <a
                        href="#"
                        className="text-green-600 hover:text-blue-900"
                        onClick={() => onEdit(template)}
                      >
                        <MdModeEdit size={25} />
                      </a>
                      <a
                        href="#"
                        className="text-red-600 hover:text-red-900 ml-4"
                        onClick={() => onDelete(template.id)}
                      >
                        <MdDelete size={25} />
                      </a>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div></div>
  );
};


// --- Add Template Form View Component ---
const AddTemplateFormView = ({ onBack, onCancel, onSubmit }) => {
  const [adminTemplates, setAdminTemplates] = useState([]);
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [adminTemplate, setAdminTemplate] = useState("");
  const [showToken, setShowTokens] = useState(false);
  const handleShowTokens = () => {
    setShowTokens(true);
  }
  const handleCancleToken = () => {
    setShowTokens(false)
  }
const[key,setKey]=useState("")
  useEffect(() => {
    const fetchAdminTemplates = async () => {
      const token = sessionStorage.getItem("authToken");
      try {
        const response = await axios.get(
          "https://tracsdev.apttechsol.com/api/create-template",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setAdminTemplates(response.data.admintemplates || []);
      } catch (err) {
        console.error("Error fetching admin templates:", err);
      }
    };

    fetchAdminTemplates();
  }, []);

  // ✅ FIXED async handleSubmit
  const navigate=useNavigate();
const handleSubmit = async (e) => {
  e.preventDefault();

  if (!title || !category || !description || !adminTemplate) {
    alert("Please fill in all required fields");
    return;
  }

  const formData = new FormData();
  formData.append("title", title);
  formData.append("category_id", category);
  formData.append("admin_template_id", adminTemplate);
  formData.append("description", description);

  // ✅ Proper logging
  console.log("---- FormData Values ----");
  for (let pair of formData.entries()) {
    console.log(pair[0] + ": " + pair[1]);
  }

  const token = sessionStorage.getItem("authToken");

  try {
    const response = await axios.post(
      "https://tracsdev.apttechsol.com/api/store-template",
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    alert(response.data.message || "Template added successfully!");
    onBack();
    window.location.reload();

  } catch (error) {
    console.log(error.response?.data?.message || "Error adding the Template");
    alert("Error adding the Template");
  }
};
const [key2,setKey2]=useState("")
useEffect(()=>{
  const fetchKey=async()=>{
    const token=sessionStorage.getItem("authToken");
    try{
const response=await axios.get("https://tracsdev.apttechsol.com/api/view-introduction-email-list",{
  headers:{Authorization:`Bearer ${token}`}
});
setKey2(response.data.keyfields.find(item=>item.id === 14)?.description)
    }catch{

    }
  };fetchKey()
},[])
const stripHtml = (html = "") => {
    const div = document.createElement("div");
    div.innerHTML = html;

    // convert <br> and <p> to line breaks
    div.querySelectorAll("br").forEach(br => br.replaceWith("\n"));
    div.querySelectorAll("p").forEach(p => {
      p.insertAdjacentText("afterend", "\n");
    });

    return div.textContent.trim();
  };
  const [copiedMsg, setCopiedMsg] = useState("")
  const copyToken = async (token) => {
    try {
      await navigator.clipboard.writeText(token);

      setCopiedMsg(`${token} copied!`);

      setTimeout(() => {
        setCopiedMsg("");
      }, 1000);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };
  const [guide, setGuide] = useState(false);
  const[guidetip,setGuideTip]=useState("")
  const [showad, setShowad] = useState(false);
useEffect(() => {
  const fetchGuide = async () => {
    const token = sessionStorage.getItem("authToken");

    try {
      const response = await axios.get(
        "https://tracsdev.apttechsol.com/api/guide_tips_api",
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      const guideItem = response.data.guidetips.find(item => item.id === 16);

      if (guideItem) {
        setGuideTip(guideItem.description);
      }

    } catch (err) {
      console.log("guideTip not found");
    }
  };

  fetchGuide();
}, []);
  return (
    <div>
      {showToken && <div className='overlay2'>
        <div className='contactsForm3'>
          <div style={{ display: "flex", justifyContent: "space-between", padding: "16px", borderBottom: "1px solid black" }}>
            <div><h2>List of Tokens</h2>
              <p className='iahdjawdapppp'>Click any token to copy it into clipboard</p></div>
            <div onClick={() => { setShowTokens(false) }}> <ImCross /></div>
          </div>
          <div className=' recipient_Data'><span style={{ marginRight: "6px", marginTop: "3px" }}><FaUserTag size={13} /></span><h6> Recipient Data</h6></div>
          <div className='dataofTokens2'>
            <div className='dtone1' onClick={() => copyToken("[[name_1]]")}><div><h2 id="nameText">I) [[name_1]]</h2></div>
              <div><p>Click on token to copy </p></div></div>
            <div className='dtone2' onClick={() => copyToken("[[name_2]]")}><div><h2>II) [[name_2]]</h2></div>
              <div><p>Click on token to copy </p></div></div>
          </div>
          {
            <div style={{ marginLeft: "20px" }}>{copiedMsg}</div>
          }
          <div style={{ display: "flex", justifyContent: "flex-end" }}><div className='listtempclos' ><button onClick={() => { setShowTokens(false) }}>Close</button></div></div>

        </div></div>}
      <div className="bg-white p-3 sm:p-3 rounded-xl shadow-md animate-fade-in mb-4 mailHeading">
        <h2>Add Email Template</h2>
      </div>
      <div className="flex justify-between items-center mb-6"><button
        onClick={onBack}
        className="text-sm  hover:text-gray-900" style={{ color: " rgb(37, 99, 235)" }}
      >
        &larr; Back to list
      </button>
        <button className='guideButton' onClick={() => setGuide((prev) => !prev)}><span style={{ marginTop: "2.5px", marginRight: "7px" }}><FaQuestionCircle /></span>Guide and Tips <span style={{ marginTop: "-4px", marginLeft: "5px" }}>{guide ? <RiArrowDropUpLine size={28} /> : <RiArrowDropDownLine size={28} />}</span></button>

      </div>
      {guide 
      && <div className="bg-white p-6 sm:p-8 rounded-xl shadow-md animate-fade-in mb-4">
     <div dangerouslySetInnerHTML={{ __html: guidetip}}></div>
       
      </div>}
      <div className="bg-white p-6 sm:p-8 rounded-xl shadow-md animate-fade-in">


        <form >
          <div className="space-y-6">
            <div><h2 className='awodndh2'>1. Template Identification</h2></div>
            {/* Title */}
            <div>
              <label
                htmlFor="title"
                className="block text-sm font-medium text-gray-700 dawdawlab"
              >
                Title <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="e.g., Welcome Email"
                required
              />
            </div>

            {/* Category */}
            <div className='lablexcat'>
              <label
                htmlFor="category"
                className="block text-sm font-medium text-gray-700 dawdawlab"
              >
                Category <span className="text-red-500">*</span>
              </label>
              <select
                id="category"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                required
              >
                <option value="">Select a category</option>
                <option value="1">Introduction-Email</option>

                <option value="4">Follow Up</option>

                <option value="6">Reply-Email</option>
              </select>
            </div>

            {/* Admin Templates */}
            <div className='lablexcat'>
              <label
                htmlFor="admin-templates"
                className="block text-sm font-medium text-gray-700 dawdawlab"
              >
                Admin Templates
              </label>
              <select
                id="admin-templates"
                value={adminTemplate}
                onChange={(e) => {
                  const selectedId = e.target.value;
                  setAdminTemplate(selectedId);
                  const selectedTemplate = adminTemplates.find(
                    (t) => t.id === parseInt(selectedId)
                  );
                  if (selectedTemplate) {
                    setDescription(selectedTemplate.email_body);
                  }
                }}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"

              >
                <option value="">Select an Admin Template</option>
                {adminTemplates.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.template_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Email Body */}

          </div>


        </form>
      </div>
      <div className="bg-white p-6 sm:p-8 rounded-xl shadow-md animate-fade-in mt-5">
        <div className='messtokescon'><div><h2 className='awodndh2'>2. Message Content</h2></div>
          <div className='listnihfdbutton1'><button className='listnihfdbutton' onClick={handleShowTokens}>List of Tokens</button><div
            className="iconWrapper"
            onMouseEnter={() => setShowad(true)}
            onMouseLeave={() => setShowad(false)}
          >
            <FaQuestionCircle style={{ marginLeft: "10px", cursor: "pointer" }} />

            {showad && (
              <div className='showad'>
               <div dangerouslySetInnerHTML={{ __html:key2}}></div>
              </div>
            )}
          </div></div> 
          </div>
        <div>

          <label
            htmlFor="email-body"
            className="block text-sm mt-3 font-medium text-gray-700 dawdawlab"
          >
            Email Body <span className="text-red-500">*</span>
          </label>
          <ReactQuill
            theme="snow"
            value={description}
            onChange={setDescription}
            className="mt-1 block w-full rounded-md"
            placeholder="Enter your email content here"
          />
        </div>


      </div>
      <div className="bg-white mb-5 p-6 sm:p-8 rounded-xl shadow-md animate-fade-in mt-5">
        <div className="mt-0 flex justify-end eagfadfbutton">
          <div>
            <button
              type="button"
              onClick={onCancel}
              className="bg-gray-200 text-gray-700 px-4 py-2 rounded-lg w-full"
            >
              Cancel
            </button>
          </div>

          <div className='nuawdbwapbutton'>
            <button
              onClick={handleSubmit}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg w-full"
            >
              Save Template
            </button>
          </div>
        </div>

      </div>
    </div>
  );

};
//Edit Template




const EditTemplateFormView = ({ template, onBack, onCancel }) => {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [adminTemplate, setAdminTemplate] = useState("");
  const [adminTemplates, setAdminTemplates] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [guide, setGuide] = useState(false);
  const [showad, setShowad] = useState(false);
   const [showToken, setShowTokens] = useState(false);
    const [copiedMsg, setCopiedMsg] = useState("");
    const [key2,setKey2]=useState("")
useEffect(()=>{
  const fetchKey=async()=>{
    const token=sessionStorage.getItem("authToken");
    try{
const response=await axios.get("https://tracsdev.apttechsol.com/api/view-introduction-email-list",{
  headers:{Authorization:`Bearer ${token}`}
});
setKey2(response.data.keyfields.find(item=>item.id === 14)?.description)
    }catch{

    }
  };fetchKey()
},[])
  const copyToken = async (token) => {
    try {
      await navigator.clipboard.writeText(token);

      setCopiedMsg(`${token} copied!`);

      setTimeout(() => {
        setCopiedMsg("");
      }, 1000);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };
    useEffect(() => {
    const fetchAdminTemplates = async () => {
      const token = sessionStorage.getItem("authToken");
      try {
        const response = await axios.get(
          "https://tracsdev.apttechsol.com/api/create-template",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setAdminTemplates(response.data.admintemplates || []);
      } catch (err) {
        console.error("Error fetching admin templates:", err);
      }
    };

    fetchAdminTemplates();
  }, []);
  const handleShowTokens = () => {
    setShowTokens(true);
  }
  // ✅ Convert template.id to base64
  const base64Id = btoa(template?.id);
  const cleanHTML = (html) => {
    if (!html) return "";
    return html.replace(/<[^>]+>/g, ""); // removes all HTML tags
  };
  useEffect(() => {
    let isCalled = false;

    const fetchTemplateById = async () => {
      if (isCalled || !base64Id) return;
      isCalled = true;

      const token = sessionStorage.getItem("authToken");

      try {
        // ✅ Fetch selected template details
        const response = await axios.get(
          `https://tracsdev.apttechsol.com/api/edit-template/${base64Id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = response.data?.template;
        if (data) {
          setTitle(data.template_name || "");
          setCategory(data.category_id?.toString() || "");
          setDescription(cleanHTML(data.email_body || ""));

        }
      } catch (err) {
        console.error("Error fetching template:", err);
        setMessage(err.response?.data?.message || "Failed to fetch template.");
      } finally {
        setLoading(false);
      }
    };

    fetchTemplateById();
  }, [base64Id]);
  useEffect(() => {
    const fetchTemplates = async () => {
      const token = sessionStorage.getItem("authToken");

      try {
        const response = await axios.get(
          "https://tracsdev.apttechsol.com/api/create-template",
          {
            headers: { Authorization: token },
          }
        );

        const templates = response.data?.admintemplates || [];
        setAdminTemplates(templates);

        console.log("Fetched Admin Templates:", templates);
      } catch (err) {
        console.error("Error fetching admin templates:", err);
      }
    };

    fetchTemplates();
  }, []);
  // ✅ Fetch all admin templates for dropdown
  useEffect(() => {
    const fetchAdminTemplates = async () => {
      const token = sessionStorage.getItem("authToken");

      try {
        const response = await axios.get(
          "https://tracsdev.apttechsol.com/api/admin-template-list",
          {
            headers: { Authorization: token },
          }
        );

        if (response.data?.adminTemplates) {
          setAdminTemplates(response.data.adminTemplates);
        }
      } catch (err) {
        console.error("Error fetching admin templates:", err);
      }
    };

    fetchAdminTemplates();
  }, []);

  // ✅ Handle update submit
  // ✅ Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = sessionStorage.getItem("authToken");

    try {
      const response = await axios.post(
        "https://tracsdev.apttechsol.com/api/store-template",
        {
          title: title,
          category_id: category,
          description: description,
          id: atob(base64Id), // decoded ID for update
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      alert("Template updated successfully!");
      window.location.reload();
    } catch (error) {
      alert(error.response?.data?.message || "Failed to update template.");

    }
  };


  if (loading) {
    return (
      <div className="p-6 text-center text-gray-500">
        Fetching template details...
      </div>
    );
  }
  const stripHtml = (html = "") => {
    const div = document.createElement("div");
    div.innerHTML = html;

    // convert <br> and <p> to line breaks
    div.querySelectorAll("br").forEach(br => br.replaceWith("\n"));
    div.querySelectorAll("p").forEach(p => {
      p.insertAdjacentText("afterend", "\n");
    });

    return div.textContent.trim();
  };
  
  return (
   <div>
     {showToken && <div className='overlay2'>
        <div className='contactsForm3'>
          <div style={{ display: "flex", justifyContent: "space-between", padding: "16px", borderBottom: "1px solid black" }}>
            <div><h2>List of Tokens</h2>
              <p className='iahdjawdapppp'>Click any token to copy it into clipboard</p></div>
            <div onClick={() => { setShowTokens(false) }}> <ImCross /></div>
          </div>
          <div className=' recipient_Data'><span style={{ marginRight: "6px", marginTop: "3px" }}><FaUserTag size={13} /></span><h6> Recipient Data</h6></div>
          <div className='dataofTokens2'>
            <div className='dtone1' onClick={() => copyToken("[[name_1]]")}><div><h2 id="nameText">I) [[name_1]]</h2></div>
              <div><p>Click on token to copy </p></div></div>
            <div className='dtone2' onClick={() => copyToken("[[name_2]]")}><div><h2>II) [[name_2]]</h2></div>
              <div><p>Click on token to copy </p></div></div>
          </div>
          {
            <div style={{ marginLeft: "20px" }}>{copiedMsg}</div>
          }
          <div style={{ display: "flex", justifyContent: "flex-end" }}><div className='listtempclos' ><button onClick={() => { setShowTokens(false) }}>Close</button></div></div>

        </div></div>}
      <div className="bg-white p-3 sm:p-3 rounded-xl shadow-md animate-fade-in mb-4 mailHeading">
        <h2>Edit Email Template</h2>
      </div>
      <div className="flex justify-between items-center mb-6"><button
        onClick={onBack}
        className="text-sm  hover:text-gray-900" style={{ color: " rgb(37, 99, 235)" }}
      >
        &larr; Back to list
      </button>
        <button className='guideButton' onClick={() => setGuide((prev) => !prev)}><span style={{ marginTop: "2.5px", marginRight: "7px" }}><FaQuestionCircle /></span>Guide and Tips <span style={{ marginTop: "-4px", marginLeft: "5px" }}>{guide ? <RiArrowDropUpLine size={28} /> : <RiArrowDropDownLine size={28} />}</span></button>

      </div>
      {guide && <div className="bg-white p-6 sm:p-8 rounded-xl shadow-md animate-fade-in mb-4">
        <div className='hiw'><span style={{ marginRight: "6px", marginTop: "4px" }}><FaWandMagicSparkles /></span><h6>How it works</h6></div>
        <ul className="list-disc pl-5">
          <li>Identify your template with a unique name.</li>
          <li>Build message content using editor or HTML.</li>
          <li>Personalize using recipient tokens.</li>
        </ul>
      </div>}
      <div className="bg-white p-6 sm:p-8 rounded-xl shadow-md animate-fade-in">


        <form >
          <div className="space-y-6">
            <div><h2 className='awodndh2'>1. Template Identification</h2></div>
            {/* Title */}
            <div>
              <label
                htmlFor="title"
                className="block text-sm font-medium text-gray-700 dawdawlab"
              >
                Title <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="e.g., Welcome Email"
                required
              />
            </div>

            {/* Category */}
            <div className='lablexcat'>
              <label
                htmlFor="category"
                className="block text-sm font-medium text-gray-700 dawdawlab"
              >
                Category <span className="text-red-500">*</span>
              </label>
                <select
            className="w-full border rounded px-3 py-2"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="">Select a category</option>
            <option value="1">Introduction-Email</option>

            <option value="4">Follow Up</option>

            <option value="6">Reply-Email</option>
          </select>


            </div>

            {/* Admin Templates */}
            <div className='lablexcat'>
              <label
                htmlFor="admin-templates"
                className="block text-sm font-medium text-gray-700 dawdawlab"
              >
                Admin Templates
              </label>
              <select
                id="admin-templates"
                value={adminTemplate}
                onChange={(e) => {
                  const selectedId = e.target.value;
                  setAdminTemplate(selectedId);
                  const selectedTemplate = adminTemplates.find(
                    (t) => t.id === parseInt(selectedId)
                  );
                  if (selectedTemplate) {
                    setDescription(selectedTemplate.email_body);
                  }
                }}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"

              >
                <option value="">Select an Admin Template</option>
                {adminTemplates.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.template_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Email Body */}

          </div>


        </form>
      </div>
      <div className="bg-white p-6 sm:p-8 rounded-xl shadow-md animate-fade-in mt-5">
        <div className='messtokescon'><div><h2 className='awodndh2'>2. Message Content</h2></div>
          <div className='listnihfdbutton1'><button className='listnihfdbutton' onClick={handleShowTokens}>List of Tokens</button><div
            className="iconWrapper"
            onMouseEnter={() => setShowad(true)}
            onMouseLeave={() => setShowad(false)}
          >
            <FaQuestionCircle style={{ marginLeft: "10px", cursor: "pointer" }} />

            {showad && (
              <div className='showad'>
               <div dangerouslySetInnerHTML={{ __html: key2}}></div>
              </div>
            )}
          </div></div> 
          </div>
        <div>

          <label
            htmlFor="email-body"
            className="block text-sm mt-3 font-medium text-gray-700 dawdawlab"
          >
            Email Body <span className="text-red-500">*</span>
          </label>
          <ReactQuill
            theme="snow"
            value={description}
            onChange={setDescription}
            className="mt-1 block w-full rounded-md"
            placeholder="Enter your email content here"
          />
        </div>


      </div>
      <div className="bg-white mb-5 p-6 sm:p-8 rounded-xl shadow-md animate-fade-in mt-5">
        <div className="mt-0 flex justify-end eagfadfbutton">
          <div>
            <button
              type="button"
              onClick={onCancel}
              className="bg-gray-200 text-gray-700 px-4 py-2 rounded-lg w-full"
            >
              Cancel
            </button>
          </div>

          <div className='nuawdbwapbutton'>
            <button
              onClick={handleSubmit}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg w-full"
            >
              Save Template
            </button>
          </div>
        </div>

      </div>
   </div>
  );
};





